import _setHelpers from "../internals/set-helpers";
import _setIterate from "../internals/set-iterate";
var exports = {};
var SetHelpers = _setHelpers;
var iterate = _setIterate;
var Set = SetHelpers.Set;
var add = SetHelpers.add;
exports = function (set) {
  var result = new Set();
  iterate(set, function (it) {
    add(result, it);
  });
  return result;
};
export default exports;